<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">专区管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editSpecialDialog(-1)">创建专区</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
            @cell-click="toggleSelection"
        >
          <el-table-column property="id" label="序号" v-if="checkColList.indexOf('序号') > -1" width="60"></el-table-column>
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" ></el-table-column>
          <el-table-column property="name" label="专区名字" v-if="checkColList.indexOf('专区名字') > -1" ></el-table-column>
          <el-table-column property="" label="性别" v-if="checkColList.indexOf('性别') > -1" width="60">
            <template #default="scope">
              {{scope.row.sex == 1?'男':scope.row.sex == 2?'女':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="认证" v-if="checkColList.indexOf('认证') > -1" width="120">
            <template #default="scope">
              <p>职业认证：{{scope.row.jobShow?'是':'否'}}</p>
              <p>学历认证：{{scope.row.eduShow?'是':'否'}}</p>
            </template>
          </el-table-column>
          <el-table-column property="pdesc" label="专区描述" v-if="checkColList.indexOf('专区描述') > -1" ></el-table-column>
          <el-table-column property="" label="专区图片" v-if="checkColList.indexOf('专区图片') > -1" width="200">
            <template #default="scope">
              <el-image style="min-width: 80px;" :src="scope.row.img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column property="colour" label="专区颜色" v-if="checkColList.indexOf('专区颜色') > -1">
            <template #default="scope">
              <el-color-picker v-model="scope.row.colour" size="small" @change="changeColor(scope.row, scope.row.colour)"/>{{scope.row.colour}}
            </template>
          </el-table-column>
          <el-table-column property="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1"></el-table-column>
          <el-table-column property="userShowNum" label="外展用户" v-if="checkColList.indexOf('外展用户') > -1"></el-table-column>
          <el-table-column property="userNum" label="专区总用户" v-if="checkColList.indexOf('专区总用户') > -1"></el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <span>{{scope.row.state==0?'待展示':scope.row.state==1?'展示中':scope.row.state==2?'已下架':''}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editSpecialDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-if="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.$index, scope.row, 1)">上架</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="danger" v-if="scope.row.state == 1" @click="updateState(scope.$index, scope.row, 2)">下架</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BtnGroup from '../../components/BtnGroup'
import { getSpecialsSysPageList, updateSpecialsState, updateSpecialsColour } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import SpecialManageDialog from "./components/SpecialManageDialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";

export default {
  name: "SpecialManage",
  components: { BtnGroup },
  data() {
    return {

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,


      stateArray: [
        {label: '不限', value: -1},
        {label: '待展示', value: 0},
        {label: '展示中', value: 1},
        {label: '已下架', value: 2},
      ],
      state: 1,

      //刷新组
      colList: ['序号', '创建时间', '专区名字', '性别', '认证', '专区描述', '专区图片', '专区颜色', '排序', '外展用户', '专区总用户', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,
      switchLoading: false,
      switchState: 1,
    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.sex = -1;
      this.state = 1;
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['type'] = this.type;
      param['state'] = this.state;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSpecialsSysPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editSpecialDialog(idx, row) {
      let _title = '';
      let specialForm = {}
      if (idx > -1) {
        _title = '编辑专区'
        specialForm = Object.assign({}, row);
      }else {
        _title = '创建专区'
      }
      Dialog.open({
        title: _title,
        component: SpecialManageDialog,
        data: {
          specialForm: specialForm,
          ids: idx,
          width: '600px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateSpecialsState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          this.getPage()
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    },

    toggleSelection(row, column, cell, event) {

      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {

          }
        })
      }

    },

    changeColor(row, val) {
      let param = {}
      param['id'] = row.id
      param['colour'] = val
      postFormData(updateSpecialsColour, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.colour = val
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
